export const DEFAULT_INCOME_FLAT_TAX_RATES = [0.02, 0.03, 0.055, 0.085, 0.1, 0.12, 0.125, 0.14, 0.15, 0.17];

export const DEFAULT_VAT_RATES = ["zw", "np", 0, 5, 8, 23];
